import { Inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ENVIRONMENT, Logger, Platform } from "shared";

@Injectable({
  providedIn: 'root'
})
export class AuthUrlService {

  protected _token: string | null = null;
  protected rewriteRegex: RegExp;
  protected logger = new Logger('AuthUrlService');

  constructor(protected platform: Platform, 
              private authService: AuthService,
              @Inject(ENVIRONMENT) private environment: any) {
    //this.logger.debug('AuthUrlService.ctor');
    this.rewriteRegex = new RegExp(`^(?:${this.environment.serverUrl})?(?<path>.*)`);
    this.authService.getToken$().subscribe(token => {
      this.logger.debug('TOKEN', token);
      this.token = token;
    });
  }

  set token(token: string | null) {
    this.logger.debug('token', token);
    this._token = token;
  }

  get token(): string | null {
    return this._token;
  }

  rewrite(url: string): string {
    this.logger.debug('rewrite', {url, token: this.token});
    if (!this.shouldRewrite(url) || !this.token) {
      return url;
    }
    try {
      const urlObj = new URL(
        url,                             // input
        url.startsWith("http") 
          ? undefined 
          : this.environment.serverUrl   // base
      );
      urlObj.searchParams.set("cid", this.token);

      this.logger.debug('rewrite', {url, result: urlObj.toString()});
      return urlObj.toString();
    } catch {
      const separator = url.includes("?") ? "&" : "?";
      return `${url}${separator}cid=${encodeURIComponent(this.token)}`;
    }
  }

  private shouldRewrite(url: string): boolean {
    if (!(/*this.platform.is('ios') &&*/ this.platform.is('hybrid'))) {
      return false;
    } else {
      return url.startsWith(this.environment.serverUrl) || (url.startsWith("/") && !url.startsWith("//"));
    }
  }
}
